import axios from 'axios';

const api = axios.create({ baseURL: '/api', timeout: 120000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('mm_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const uploadMatchVideo = (file, metadata, onProgress) => {
  const form = new FormData();
  form.append('video', file);
  form.append('homeTeam',    metadata.homeTeam    || '');
  form.append('awayTeam',    metadata.awayTeam    || '');
  form.append('matchDate',   metadata.matchDate   || '');
  form.append('competition', metadata.competition || '');
  // Pass score — server will use these exact values in the report
  form.append('homeScore',   metadata.homeScore !== '' ? metadata.homeScore : '');
  form.append('awayScore',   metadata.awayScore !== '' ? metadata.awayScore : '');

  return api.post('/analyze/upload', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: e => { if (onProgress) onProgress(Math.round((e.loaded * 100) / e.total)); },
    // The shared 120s default is fine for quick API calls, but a real match
    // video (tens to hundreds of MB) over a real home upload connection can
    // easily take longer than that just to transfer the bytes — the request
    // was getting cut off mid-upload with "timeout of 120000ms exceeded"
    // even though the transfer was still actively progressing. Give the
    // actual video upload a much longer ceiling instead.
    timeout: 20 * 60 * 1000,
  });
};

export const getAnalysisStatus = (matchId) => api.get(`/analyze/status/${matchId}`);
export const getAllAnalyses    = ()          => api.get('/analyze/all');
export const getSeedReports   = ()          => api.get('/reports');
export const getSeedReport    = (id)        => api.get(`/reports/${id}`);
export const checkHealth      = ()          => api.get('/health');

export default api;
